module.exports = __webpack_public_path__ + "static/pulsio_box_with_orange_drink-228b717973e73ff1c244115951d4ae3f.png";